import config from "config";
import gsap from "gsap";
import { Container, Graphics, Point } from "pixi.js";
import tools from "tools";
const DECAY = 0.96; // speed
const BOUNCING_SPRINGESS = 0.7; // back speed

export default class Scroll extends Container {
  constructor() {
    super();
    tools.autobind(this);
    this.isDown = false;
    this.isMoving = false;
    this._viewX = 100;
    this._viewY = 100;
    this._velocityY = 0;
    this._contentY = 0;
    this._lastPoint = new Point();
    this._bg = new Graphics();
    this._container = new Container();
    this.__mask = new Graphics();
    this._init();
  }
  _init() {
    this._bg.beginFill(0x0000ff, .001);
    this._bg.drawRect(0, 0, 1, 1);
    this._bg.endFill();
    this.addChild(this._container);
    this.__mask.beginFill(0xff0000, .4);
    this.__mask.drawRect(0, 0, 1, 1);
    this.__mask.endFill();
    this.__mask.scale.set(this.viewX, this.viewY);
    this.__mask.isMask = true;
    this._container.mask = this.__mask;
    this.addChild(this.__mask);
    this._initEvents();
  }
  _initEvents() {
    this.interactive = true;
    this.on('pointerdown', this._onDragStart).on('pointerup', this._onDragEnd).on('pointerupoutside', this._onDragEnd).on('pointermove', this._onDragMove);
    config.app.on("onUp", this._onDragEnd);
    config.app.on("onWheel", this._onWheel);
  }
  _onDragStart(event) {
    this.scrollTween && this.scrollTween.kill();
    this._velocityY = 0;
    this.data = event.data;
    this.localPosition = this.data.getLocalPosition(this._container);
    this.newPosition = this.data.getLocalPosition(this);
    this.isDown = true;
    this.isMoving = false;
  }
  _onDragEnd() {
    this.isDown = false;
    this.isMoving = false;
  }
  _onDragMove(event) {
    if (this.isDown) {
      this.newPosition = this.data.getLocalPosition(this);
    }
    this.isMoving = true;
  }
  _onWheel(event) {
    if (!this.visible) {
      return;
    }
    let pos = this._container.y;
    pos -= event.deltaY * 2.5;
    this.scrollTween && this.scrollTween.kill();
    this.scrollTween = gsap.to(this._container, {
      duration: .4,
      y: pos,
      onUpdate: this._checkPosition
    });
  }
  _checkPosition() {
    if (this._container.y > 0 || this._viewY >= this._container.height) {
      this._container.y *= .5;
      this.scrollTween && this.scrollTween.kill();
    } else if (this._container.y < this.viewY - this._container.height) {
      this.scrollTween && this.scrollTween.kill();
      this._container.y = this.viewY - this._container.height - (this.viewY - this._container.height - this._container.y) * .5;
    }
  }
  _back() {
    if (this._container.y > 0 || this._viewY >= this._container.height) {
      this._container.y *= BOUNCING_SPRINGESS;
    } else if (this._container.y < this.viewY - this._container.height) {
      this._container.y = this.viewY - this._container.height - (this.viewY - this._container.height - this._container.y) * BOUNCING_SPRINGESS;
    }
  }
  _getMovement(posRef, point) {
    let directionY;
    posRef.y1 = posRef.y2;
    posRef.y2 = point.y;
    directionY = point.y > posRef.y1 ? 1 : -1;
    return directionY * tools.distance({
      x: 0,
      y: posRef.y1
    }, {
      x: 0,
      y: posRef.y2
    });
  }
  set viewX(val) {
    this._viewX = val;
    this.__mask.scale.x = this._viewX;
  }
  get viewX() {
    return this._viewX;
  }
  set viewY(val) {
    this._viewY = val;
    this.__mask.scale.y = this._viewY;
  }
  get viewY() {
    return this._viewY;
  }
  set axe(val) {
    this._axe = val;
  }
  get contentY() {
    return this._contentY;
  }
  set contentY(val) {
    this._contentY = val;
    this._container.y = this._contentY;
  }
  goToDown() {
    this._container.y = this.viewY - this._container.height;
  }
  add(displayObject) {
    this._container.addChild(this._bg);
    this._container.addChild(displayObject);
    this._bg.scale.set(this._container.width, this._container.height);
  }
  clear() {
    this.isDown = false;
    this.isMoving = false;
    this._bg.scale.set(1, 1);
    this._container.removeChildren();
    this._container.position.set(0, 0);
  }
  update() {
    if (!this.visible) {
      return;
    }
    if (!this.isDown) {
      this._velocityY *= DECAY;
      this._container.y += this._velocityY;
      this._back();
    } else {
      this.newPosition && (this._container.y = this.newPosition.y - this.localPosition.y);
      this._velocityY = this._getMovement(this._lastPoint, this._container.position);
      this._checkPosition();
    }
  }
  dispose() {
    this.off('pointerdown', this._onDragStart).off('pointerup', this._onDragEnd).off('pointerupoutside', this._onDragEnd).off('pointermove', this._onDragMove);
    this.destroy(true);
  }
}
